module.exports = new __parcel__URL__("kuma_ancestor_shrine_level_2.91efe0b0.png").toString();